import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom'; // Import useParams
import { useHistory } from 'react-router-dom';
import { fetchData, postData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CloseIcon from '@mui/icons-material/Close';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';

const ItemEdit = ({ match }) => {
    const recordId = match.params.id; // Assuming you're using React Router
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedPGCategory, setSelectedPGCategory] = useState("");
    const [selectedItemGroup, setSelectedItemGroup] = useState("");

    const [dropdownCategoryOptions, setDropdownCategoryOptions] = useState([]);
    const [dropdownPGCategoryOptions, setDropdownPGCategoryOptions] = useState([]);
    const [dropdownItemGroupOptions, setDropdownItemGroupOptions] = useState([]);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchDropdownCategoryOptions();
        fetchDropdownPGCategoryOptions();
        fetchDropdownItemGroupOptions();
    }, []);

    const fetchDropdownCategoryOptions = () => {
        fetchData('ItemApi', `/Category/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownCategoryOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Category dropdown options:', error);
            });
    };

    const fetchDropdownPGCategoryOptions = () => {
        fetchData('ItemApi', `/PGCategory/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownPGCategoryOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Pg Category dropdown options:', error);
            });
    };

    const fetchDropdownItemGroupOptions = () => {
        fetchData('ItemApi', `/ItemGroup/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownItemGroupOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Pg Category dropdown options:', error);
            });
    };

    const [formData, setFormData] = useState({
        Code: '',
        Name: '',
        PF: '',
        ISG: '',
        PurchaseRate: '',
        MRP: '',
        HSNCode: '',
        GSTRate: '',
        DiscountPercentage: '',
        CategoryId: '',
        PGCategoryId: '',
        ItemGroupId: '',
    });


    useEffect(() => {
        fetchData('ItemApi', `/ItemDetails/${recordId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    setFormData(response.response_data);
                    setFormData(prevData => ({
                        ...prevData,
                        UpdatedBy: userId,
                    }));
                    setSelectedCategory(response.response_data.CategoryId);
                    setSelectedPGCategory(response.response_data.PGCategoryId);
                    setSelectedItemGroup(response.response_data.ItemGroupId);
                }
            })
            .catch((error) => {
                console.error('Error fetching Item Details:', error);
            });
    }, []);

    const handleChange = event => {
        const { name, value, type } = event.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };

    const handleSubmit = event => {
        event.preventDefault();

        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: userId,
        }));

        updateData('ItemApi', `${recordId}`, formData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/ItemIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });

    };

    return (

        <div className="w-full max-w-sm container mt-6 mx-auto">
            <form onSubmit={handleSubmit}>
                <div className='w-full mb-2 flex items-center'>
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}> Item - Edit</h6>
                    <Button

                        style={{ marginLeft: '8px', color: 'darkgreen', fontWeight: 'bolder' }}
                        onClick={handleSubmit}
                    >
                        <DoneAllIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} /> UPDATE
                    </Button>

                    <Button

                        component={Link}
                        to="/ItemIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                    >
                        <CloseIcon style={{ color: 'darkred', fontWeight: 'bolder' }} /> CANCEL
                    </Button>
                </div>
                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>
                {/* Render fetched data */}
                <div className="w-full mb-4 flex">
                    <div className="w-4/5 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            Item Name
                            <span className="text-red-500">*</span>
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={formData.Name}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter Name"
                            name='Name'
                        />
                    </div>

                    <div className="w-1/5 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            Item Code
                            <span className="text-red-500">*</span>
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={formData.Code}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter Code"
                            name='Code'
                        />
                    </div>

                </div>

                <div className="w-full mb-4 flex">

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            Category
                            <span className="text-red-500">*</span>
                        </label>
                        <select
                            className={`custom-select ${selectedCategory ? 'fade-in' : 'fade-in'}`}
                            value={selectedCategory}
                            // onChange={(e) => setSelectedCategory(e.target.value)}
                            onChange={(e) => {
                                const selectedValue = e.target.value;
                                setSelectedCategory(selectedValue);
                                setFormData((prevFormData) => ({
                                    ...prevFormData,
                                    CategoryId: selectedValue,
                                }));
                            }}
                        >
                            <option value="">Select Category</option>
                            {dropdownCategoryOptions.map((category) => (
                                <option key={category.Id} value={category.Id}>
                                    {category.Name}
                                </option>
                            ))}
                        </select>

                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            PG Category
                            <span className="text-red-500">*</span>
                        </label>
                        <select
                            className={`custom-select ${selectedPGCategory ? 'fade-in' : 'fade-in'}`}
                            value={selectedPGCategory}
                            // onChange={(e) => setSelectedPGCategory(e.target.value)}
                            onChange={(e) => {
                                const selectedValue = e.target.value;
                                setSelectedPGCategory(selectedValue);
                                setFormData((prevFormData) => ({
                                    ...prevFormData,
                                    PGCategoryId: selectedValue,
                                }));
                            }}
                        >
                            <option value="">Select PG Category</option>
                            {dropdownPGCategoryOptions.map((category) => (
                                <option key={category.Id} value={category.Id}>
                                    {category.Name}
                                </option>
                            ))}
                        </select>

                    </div>


                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            Item Group
                            <span className="text-red-500">*</span>
                        </label>
                        <select
                            className={`custom-select ${selectedItemGroup ? 'fade-in' : 'fade-in'}`}
                            value={selectedItemGroup}
                            //onChange={(e) => setSelectedItemGroup(e.target.value)}
                            onChange={(e) => {
                                const selectedValue = e.target.value;
                                setSelectedItemGroup(selectedValue);
                                setFormData((prevFormData) => ({
                                    ...prevFormData,
                                    ItemGroupId: selectedValue,
                                }));
                            }}
                        >
                            <option value="">Select Item Group</option>
                            {dropdownItemGroupOptions.map((category) => (
                                <option key={category.Id} value={category.Id}>
                                    {category.Name}
                                </option>
                            ))}
                        </select>

                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            PF
                            <span className="text-red-500">*</span>
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={formData.PF}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter PF"
                            name='PF'
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            ISG
                            <span className="text-red-500">*</span>
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={formData.ISG}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter ISG"
                            name='ISG'
                        />
                    </div>

                </div>

                <div className="w-full mb-4 flex">
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            Purchase Rate
                            <span className="text-red-500">*</span>
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={formData.PurchaseRate}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter Purchase Rate"
                            style={{ textAlign: 'right' }}
                            name='PurchaseRate'
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            MRP
                            <span className="text-red-500">*</span>
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={formData.MRP}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter MRP"
                            style={{ textAlign: 'right' }}
                            name='MRP'
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            Discount %
                            <span className="text-red-500">*</span>
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={formData.DiscountPercentage}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter Discount %"
                            style={{ textAlign: 'right' }}
                            name='DiscountPercentage'
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            GST Rate
                            <span className="text-red-500">*</span>
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={formData.GSTRate}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter GST Rate"
                            style={{ textAlign: 'right' }}
                            name='GSTRate'
                        />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            HSN Code
                            <span className="text-red-500">*</span>
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={formData.HSNCode}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter HSN Code"
                            name='HSNCode'
                        />
                    </div>

                </div>
            </form>
        </div>

    );
};

export default ItemEdit;
